import { useEffect, useState } from 'react';
import { type GlobalToken, theme } from 'antd';
import Debounce from 'lodash/debounce';

const getIsMobile = (token: GlobalToken) => {
  return window.innerWidth < token.screenMDMin;
};

export const useIsMobile = () => {
  const { token } = theme.useToken();
  const [isMobile, setIsMobile] = useState(getIsMobile(token));

  // useBreakpoint would be preferable, but on every new page render
  // it resets back to an empty object. This is equivalent, but without
  // that problem.
  useEffect(() => {
    window.addEventListener(
      'resize',
      Debounce(() => {
        setIsMobile(getIsMobile(token));
      }, 300)
    );
  }, [token]);

  return isMobile;
};
